/**
 * 防水套餐组合配置 - 表格选项
 * 字段对齐接口文档：pure_water_goods_combo 响应体
 */
import { formatterDateToUTC } from "@/util/util";

export const comboOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  index: false,
  selection: true,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  columnBtn: false,
  menuWidth: "200",
  labelWidth: "120",
  column: [
    {
      label: "套餐名称",
      prop: "name",
      type: "input",
      search: true,
      span: 8,
      placeholder: "请输入套餐名称",
      width: "180"
    },
    {
      label: "组合阶段",
      prop: "concatName",
      type: "input",
      span: 24,
      overHidden: true,
      addVisdiplay: false,
      editVisdiplay: false,
      minWidth: "300"
    },
    {
      label: "排序值",
      prop: "sort",
      type: "number",
      span: 8,
      addVisdiplay: false,
      editVisdiplay: false,
      width: "90"
    },
    {
      label: "创建时间",
      prop: "createTime",
      type: "datetime",
      span: 8,
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      formatter: function (row) {
        return row.createTime ? formatterDateToUTC(row.createTime * 1) : "";
      },
      addVisdiplay: false,
      editVisdiplay: false,
      width: "170"
    },
    {
      label: "创建人",
      prop: "createBy",
      type: "input",
      span: 8,
      addVisdiplay: false,
      editVisdiplay: false,
      width: "100"
    },
    {
      label: "更新时间",
      prop: "updateTime",
      type: "datetime",
      span: 8,
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      formatter: function (row) {
        return row.updateTime ? formatterDateToUTC(row.updateTime * 1) : "--";
      },
      addVisdiplay: false,
      editVisdiplay: false,
      hide: true,
      width: "170"
    },
    {
      label: "更新人",
      prop: "updateBy",
      type: "input",
      span: 8,
      addVisdiplay: false,
      editVisdiplay: false,
      hide: true,
      width: "100"
    }
  ]
};
